wbApp.factory('taxDocumentsSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {

        var TaxDocuments = $resource('/Api/TaxDocuments/GetBriefBySemester', {}, {
            'query': { method: 'GET', isArray: true },
            'getStormwareTaxDocumentExport': { method: 'POST', url: '/Api/TaxDocuments/GetStormwareTaxDocumentExport' },
            'getMoneyS3TaxDocumentExport': { method: 'POST', url: '/Api/TaxDocuments/GetMoneyS3TaxDocumentExport' },
            'getCsvTaxDocumentExport': { method: 'POST', url: '/Api/TaxDocuments/GetCsvTaxDocumentExport' },
        });

        function GetBriefBySemester(semesterID) {
            return repositorySvc.get(TaxDocuments, { semesterID: semesterID });
        }

        function getStormwareTaxDocumentExport(accountingBookID, taxDocumentIDs, success, error) {
            return repositorySvc.customPost('getStormwareTaxDocumentExport', TaxDocuments, {
                accountingBookID: accountingBookID,
                taxDocumentIDs: taxDocumentIDs
            },
            success,
            error);
        }

        function getMoneyS3TaxDocumentExport(accountingBookID, taxDocumentIDs, success, error) {
            return repositorySvc.customPost('getMoneyS3TaxDocumentExport', TaxDocuments, {
                accountingBookID: accountingBookID,
                taxDocumentIDs: taxDocumentIDs
            },
            success,
            error);
        }

        function getCsvTaxDocumentExport(accountingBookID, taxDocumentIDs, success, error) {
            return repositorySvc.customPost('getCsvTaxDocumentExport', TaxDocuments, {
                    accountingBookID: accountingBookID,
                    taxDocumentIDs: taxDocumentIDs
                },
                success,
                error);
        }

        return {
            GetBriefBySemester: GetBriefBySemester,
            getStormwareTaxDocumentExport: getStormwareTaxDocumentExport,
            getMoneyS3TaxDocumentExport: getMoneyS3TaxDocumentExport,
            getCsvTaxDocumentExport: getCsvTaxDocumentExport
        }
    }]);